import { Flow, flowMeta, howItWorks } from '../content/site';
import { Arrow } from './Icons';
import { FlowSwitch } from './FlowSwitch';
import { Reveal } from './Reveal';
import './HowItWorks.css';

type Props = {
  flow: Flow | null;
  onChange: (flow: Flow) => void;
};

export function HowItWorks({ flow, onChange }: Props) {
  // Before a choice is made, show the practice journey as the default view.
  const active: Flow = flow ?? 'practice';
  const journey = howItWorks[active];

  return (
    <section className="section" id="how-it-works">
      <div className="container">
        <Reveal>
          <div className="how__head">
            <div className="section-head section-head--wide how__headings">
              <p className="eyebrow">How it works</p>
              <h2 className="section-title">{journey.title}</h2>
              <p className="section-lead">{journey.lead}</p>
            </div>
            <FlowSwitch
              value={active}
              onChange={onChange}
              label="Showing"
            />
          </div>
        </Reveal>

        <ol
          className="how__steps"
          id={`flow-panel-${flowMeta[active].slug}`}
          role="tabpanel"
          aria-labelledby={`flow-tab-${flowMeta[active].slug}`}
          key={active}
        >
          {journey.steps.map((step, index) => (
            <li key={step.title} className="how__step">
              <Reveal delay={index * 60}>
                <div className="step">
                  <div className="step__marker" aria-hidden>
                    <span className="step__number">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <div className="step__content">
                    <p className="step__when">{step.when}</p>
                    <h3 className="step__title">{step.title}</h3>
                    <p className="step__body">{step.body}</p>
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>

        <Reveal>
          <div className="how__footer">
            <p className="how__footer-text">
              Every stage is confidential, and you can stop at any point without
              obligation.
            </p>
            <a className="btn btn--brass" href="#enquire">
              {flowMeta[active].cta}
              <Arrow className="btn__arrow" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
